import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
import { NEXTGEN } from '../../config/Profiler_enum';

const questionConfig = getQuestionConfig(ProfilerQuestionID.NEXT_GEN);

const NextGen = ({
  questionId = ProfilerQuestionID.NEXT_GEN,
  title = questionConfig?.subtitle,
  subtitle = questionConfig?.question,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
}) => {
  const isControlled = typeof value !== 'undefined';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (optionValue) => {
    if (!isControlled) {
      setInternalValue(optionValue);
    }
    onChange?.(optionValue);
     onSubmit?.({
      question: [
        { id: questionId, value: optionValue }
      ]
    });
  };


  return (
    <Box sx={cardStyles({ maxWidth: { xs: 210, md: 300 }, })}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, justifyContent: 'space-between' }}>
          <CardHeader
              titleBold = {true}
              title={title}
              alignItems='center'
          />
          <Box
            component='img'
            alt='Next generation'
            width={150}
            height={150}
            src={PROFILER_IMAGES.nextGen}
            sx={{ alignSelf: 'center' }}
          />
          <Typography variant='p3' align='center'>
            {subtitle}
          </Typography>
        <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
          {NEXTGEN.map((option) => (
            <CustomButton
              key={option.value.toString()}
              label={option.label}
              onClick={() => handleSelect(option.value)}
              size='small'
              sx={{ width: '100%', mt: 'auto' }}
              variant={option.value === true ? 'contained' : 'outlined'}
            />
          ))}
        </Box>
        </Box>
        
      </Box>
    </Box>
  );
};

export default NextGen;
